var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.15 5a4.11 4.11 0 0 0-4.07 3.18A4 4 0 0 0 10 13v6h2V7h2v12h2V7h2V5h-7.85ZM8 9a2 2 0 0 1 2-2v4a2 2 0 0 1-2-2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }